"use client";

import { useEffect } from "react";
import Header from "@/components/headerV2";
import Hero from "@/components/hero";
import Tickets from "@/components/tickets";
import Countdown from "@/components/countdown";
import Games from "@/components/games";
import Partner from "@/components/partner";
import Sponsors from "@/components/sponsors";
import FAQ from "@/components/faq";
import Footer from "@/components/footer";
import BottomMenu from "@/components/bottomMenu";

export default function Home() {
  useEffect(() => {
    const targets = document.querySelectorAll<HTMLElement>(
      ".reveal-up, .reveal-scale, .float-soft",
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        // Large sections on mobile may never reach 20% visible at once.
        threshold: 0.05,
        rootMargin: "0px 0px -5% 0px",
      },
    );

    targets.forEach((target) => observer.observe(target));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="site-shell">
      <Header />
      <div style={{ paddingTop: 100 }} />
      {/*<Hero />*/}
      {/*<Features />*/}
      {/*<Tickets />*/}
      {/*<Countdown />*/}
      {/*<Games />*/}
      {/*<Carousel />*/}
      {/*<Partner />*/}
      {/*<Corporate />*/}
      {/*<SocialFeed />*/}
      <FAQ />
      {/*<Sponsors />*/}
      <Footer />
      <div style={{ paddingTop: 100 }} />
      <BottomMenu />
    </div>
  );
}
